import React from "react"
import { AgGridReact } from "ag-grid-react";

import { Accessors, Common, Regex } from "../../../helper";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/stlyes/BigPicture/PPR.scss";

const DetailedViewTable = (props) => {
  const { isPassing, studentDetails } = props;

  const booleanCellRenderer = (params) => params.value ? Common.Yes_ : Common.No
  const getFullName = (params) => `${params.data.lastName} ${params.data.firstName}`

  // Here im removing (number) in header using regex
  const columnDefs = [
    { headerName: `${studentDetails.selectedValue}, ${studentDetails.selectedColumnHeader?.replace(Regex.Paranthesis, "")} (${studentDetails?.e?.length})`, field: "studentName", sortable: false, pinned: "left", valueGetter: getFullName },
    { headerName: Common.Gender, field: Accessors.Gender, sortable: true, headerClass: "custom-header" },
    { headerName: Common.PP, field: Accessors.PP, sortable: true, headerClass: "custom-header", cellRenderer: booleanCellRenderer },
    { headerName: Common.SEND, field: Accessors.Send, sortable: true, headerClass: "custom-header" },
    { headerName: Common.Eal, field: Accessors.Eal, sortable: true, headerClass: "custom-header", cellRenderer: booleanCellRenderer },
    { headerName: Common.GLD, field: Accessors.Gld, sortable: true, headerClass: "custom-header" },
    { headerName: Common.Ethnicity, field: Accessors.Ethnicity, sortable: true, headerClass: "custom-header" },
    ...(isPassing ? [{ headerName: Common.Passing, field: Accessors.Passing, sortable: true, headerClass: "custom-header" }] : []),//This line is to render passing is required or not
    { headerName: Common.Class, field: Accessors.Classname, sortable: true, headerClass: "custom-header" },
  ];


  const defaultColDef = {
    flex: 1,
    minWidth: 150,
    sortable: true,
    filter: false
  };

  if (!studentDetails.e || studentDetails.e.length === 0) {
    return (
      <div className="d-flex justify-content-center">
        <h1>{Common.NoPupilFound}</h1>
      </div>
    );
  }

  return (
    <div className="ppr-data-view-table">
      <div className="ag-theme-alpine">
        <AgGridReact columnDefs={columnDefs} defaultColDef={defaultColDef} pagination={true} paginationPageSize={20} rowData={studentDetails.e} />
      </div>
    </div>
  );
}

export { DetailedViewTable }
